<form [formGroup]="filterForm" (ngSubmit)="returnQuery()" class="filter-form">
  <ng-container *ngFor="let filter of initialFilters">
    <!-- Input -->
    <nz-form-item *ngIf="filter.element === 'input'">
      <nz-form-label [nzFor]="filter.name">{{ filter.label }}</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          [id]="filter.name"
          [type]="filter.elementType || 'text'"
          [placeholder]="filter.placeholder"
          [formControlName]="filter.name" />
      </nz-form-control>
    </nz-form-item>

    <!-- Select -->
    <nz-form-item *ngIf="filter.element === 'select'">
      <nz-form-label [nzFor]="filter.name">{{ filter.label }}</nz-form-label>
      <nz-form-control>
        <nz-select [formControlName]="filter.name" [nzId]="filter.name" nzAllowClear>
          <nz-option *ngFor="let opt of filter.selectOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </ng-container>
</form>

<div class="filter-actions">
  <button nz-button nzType="default" (click)="nzModalRef.close()" type="button">Voltar</button>
  <button nz-button nzType="primary" (click)="returnQuery()">Filtrar</button>
</div>
